import { render } from "./TermsAndConditions.vue?vue&type=template&id=23046c71"
import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Support/TermsAndConditions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23046c71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23046c71', __exports__)) {
    api.reload('23046c71', __exports__)
  }
  
  module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=23046c71", () => {
    api.rerender('23046c71', render)
  })

}


export default __exports__